import { Component, forwardRef, Input } from '@angular/core';
import { CommonModule } from '@angular/common'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'rms-toggle',
  templateUrl: './rms-toggle.component.html',
  styleUrls: ['../rms-styles.scss'],
  imports: [CommonModule],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => RmsToggleComponent),
    multi: true
  }]
})
export class RmsToggleComponent implements ControlValueAccessor {
  @Input() disabled: boolean = false;
  @Input() trueValue: any = true;
  @Input() falseValue: any = false;
  @Input() label: string = '';
  @Input() largeToggle: boolean = false;

  value: any;

  onChange = (_: any) => { };
  onTouched = () => { };

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  toggle(): void {
    if (this.disabled) return;

    this.value = this.value === this.trueValue ? this.falseValue : this.trueValue;
    this.onChange(this.value);
    this.onTouched();
  }

  isChecked(): boolean {
    return this.value === this.trueValue;
  }
}
